<template>
  <div class="fff">
    <div class="page_title">{{ $t("youWill.txt1") }}</div>
    <div class="Take">
      {{ $t("youWill.txt2") }}
    </div>
    <div class="YouWill">
      {{ $t("youWill.txt3") }}
    </div>
    <div class="loginButton">{{ $t("youWill.txt4") }}</div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "",
    };
  },
  mounted() {},
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 100%;
  position: absolute;
  height: 100%;
  background: #fff;
  overflow: hidden;
}
.Take {
  color: grey;
  line-height: 20px;
}
.Take,
.YouWill {
  font-size: 14px;
  margin-left: 5%;
  width: 85%;
  max-width: 800px;
}
.YouWill {
  color: #45484d;
  margin-top: 40px;
}
.loginButton {
  float: left;
  margin-top: 40px;
  margin-left: 5%;
  width: 280px;
  height: 44px;
  line-height: 44px;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/YouWill.vue